export default function getCookie(cname) {
  try {
    let name = cname + '='
    let decodedCookie = decodeURIComponent(document.cookie)
    let ca = decodedCookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) == ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length)
      }
    }
    return null
  } catch (err) {
    return null
  }
}

export function getStoredUserObject() {
  try {
    const raw = localStorage.getItem('userObject')
    if (!raw) {
      return null
    }
    return JSON.parse(raw)
  } catch (err) {
    return null
  }
}

export function getAuthTokenCandidates() {
  const cookieToken = getCookie('authToken')
  const userObjectToken = getStoredUserObject()?.token || null
  const tokens = []

  if (cookieToken) {
    tokens.push(cookieToken)
  }
  if (userObjectToken && userObjectToken !== cookieToken) {
    tokens.push(userObjectToken)
  }

  return tokens
}

function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export async function waitForAuthTokenCandidates({
  timeoutMs = 2000,
  intervalMs = 50,
} = {}) {
  const started = Date.now()
  let tokens = getAuthTokenCandidates()

  while (tokens.length === 0 && Date.now() - started < timeoutMs) {
    await wait(intervalMs)
    tokens = getAuthTokenCandidates()
  }

  return tokens
}
